import LFillInTheBlanksData from "../../../../doc/listening/fill-in-the-blanks/LFillInTheBlanksData.js";
import LFillInTheBlanksList from "../../../../doc/components/LFillInTheBlanksList.js";
import * as React from 'react';
export default {
  LFillInTheBlanksData,
  LFillInTheBlanksList,
  React
};